import { CSSObject } from '@chakra-ui/react';

export const ILink: CSSObject = {
  color: 'alpha.500',
  mx: '0',
  textDecoration: 'underline',
};
